// src/components/PreorderCounter.jsx
import React from "react";
import { Button } from "./ui/button";
import { Sparkles } from "lucide-react";

export default function PreorderCounter() {
  return (
    <div className="bg-white rounded-3xl p-10 shadow-2xl border border-[var(--aerzen-silver)]/40">

      {/* Early Access Tag */}
      <div
        className="inline-flex items-center gap-2 px-4 py-2 mb-5
        bg-[var(--aerzen-blue)]/10 text-[var(--aerzen-blue)]
        text-sm font-medium rounded-full"
      >
        <Sparkles className="h-4 w-4" />
        Early Access Batch · Limited Allocation
      </div>

      {/* Headline */}
      <h3 className="text-4xl sm:text-5xl font-bold text-[var(--aerzen-black)] mb-4 leading-tight">
        Pre-Book AERZEN AIR™
      </h3>

      <p className="text-[var(--aerzen-black)]/70 text-base sm:text-lg mb-8 leading-relaxed">
        India’s most thoughtfully engineered air purifiers —  
        built for children, elders, pets, and extreme pollution days.
        <br />
        Early Access customers receive <strong>priority manufacturing & delivery</strong>.
      </p>

      {/* Early Access Benefits */}
      <div className="space-y-3 mb-10 text-sm sm:text-base text-[var(--aerzen-black)]/80">
        <div>✔ Limited Early Access allocation · Controlled production batches</div>
        <div>✔ Pre-booking amount fully adjustable against final invoice</div>
        <div>✔ MRP inclusive of GST @18% · No hidden charges</div>
        <div>✔ Free 1 HEPA filter on first replacement cycle</div>
      </div>

      {/* Primary CTA */}
      <Button
        onClick={() =>
          document
            .getElementById("products")
            ?.scrollIntoView({ behavior: "smooth" })
        }
        className="w-full py-8 text-xl font-semibold rounded-2xl
          bg-[var(--aerzen-blue)] hover:bg-[#2d5bc4]
          shadow-xl hover:shadow-2xl transition-all duration-300"
      >
        Explore Models & Pre-Book
      </Button>

      {/* Timeline */}
      <div className="mt-8 text-xs sm:text-sm text-[var(--aerzen-black)]/60 text-center leading-relaxed">
        📅 <strong>Early Access Pre-Booking Opens:</strong> 15 January 2026
        <br />
        🚚 <strong>Delivery Starts:</strong> 01 May 2026 onwards
      </div>
    </div>
  );
}
